import React from "react";

import HomePage from "../StaticPages/HomePage/";

function LandingPage() {
	return <HomePage />;
}

export default LandingPage;
